<div id="pagination-cont" aria-label="Pagination Navigation">
    <div style="float: left">
        Show
        <label for="rows-per-pages" class="visuallyHidden">Number of rows to show</label>
        <select id="rows-per-pages" [(ngModel)]="rowsPerPage" (change)='changeRowsPerPage()'>
            <option *ngFor="let item of rowsPerPageOptions" 
                [value]="item" 
                attr.aria-label="Set Rows Per Page {{item}}" 
                attr.aria-current="{{item}} == {{rowsPerPage}} ? true : false">
                {{item}}</option>
        </select>
        of {{totalRecords}} rows
    </div>
    <div id="pagination-right" style="float: right">
        <div [ngClass]="{'disabled': currentPage == totalPages}">
            <!-- <i class="icon icon-chevron-right-small" (click)="currentPage < totalPages && changePage('NEXT')"></i> -->
            <!-- <i class="pi pi-angle-right" (click)="currentPage < totalPages && changePage('NEXT')"></i> -->
            <deer-icon id="pagination-next" type="right" (click)="currentPage < totalPages && changePage('NEXT')" width="20px" height="20px" tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Pagination Next"></deer-icon>
            <!-- <i id="pagination-next" class="icon icon-chevron-right-small" (click)="currentPage < totalPages && changePage('NEXT')"
                tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Pagination Next"></i> -->
        </div>
        <div [ngClass]="{'disabled': currentPage == 1}">
            <!-- <i class="icon icon-chevron-left-small" (click)="currentPage > 1 && changePage('BACK')"></i> -->
            <!-- <i class="pi pi-angle-left" (click)="currentPage > 1 && changePage('BACK')"></i> -->
            <deer-icon id="pagination-next" type="left" (click)="currentPage > 1 && changePage('BACK')" width="20px" height="20px" tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Pagination Previous"></deer-icon>
            <!-- <i id="pagination-prev" class="icon icon-chevron-left-small" (click)="currentPage > 1 && changePage('BACK')"
                    tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Pagination Previous"></i> -->
        </div>
        <div>
            Go to Page
            <label for="pages-list" class="visuallyHidden">Choose page</label>
            <select [(ngModel)]="currentPage" (change)='changePage()' id="pages-list">
                <option *ngFor="let item of pages" 
                    [value]="item" 
                    attr.aria-label="Goto Page {{item}}" 
                    attr.aria-current="{{item}} == {{currentPage}} ? true : false">
                    {{item}}</option>
            </select>
            of {{totalPages}}
        </div>
    </div>
</div>